var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-12"},[_c('ckeditor',{attrs:{"id":"terms_and_conditions","editor":_vm.editor},model:{value:(_vm.value.terms_and_conditions),callback:function ($$v) {_vm.$set(_vm.value, "terms_and_conditions", $$v)},expression:"value.terms_and_conditions"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }